/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { WeightItemDto } from './weight-item-dto';
 /**
 *
 *
 * @export
 * @interface WeightSetDto
 */
export interface WeightSetDto {

    /**
     * Inherited values overlaid with this tier’s own.
     *
     * @type {Array<WeightItemDto>}
     * @memberof WeightSetDto
     */
    effective: Array<WeightItemDto>;

    /**
     * Rows this tier stores. Sparse for the override tiers.
     *
     * @type {Array<WeightItemDto>}
     * @memberof WeightSetDto
     */
    own: Array<WeightItemDto>;

    /**
     * What the tier above resolves to. Empty at the base tier.
     *
     * @type {Array<WeightItemDto>}
     * @memberof WeightSetDto
     */
    inherited: Array<WeightItemDto>;
}
